import { render, staticRenderFns } from "./BatchCard.vue?vue&type=template&id=e7b6fbcc&scoped=true"
import script from "./BatchCard.vue?vue&type=script&lang=js"
export * from "./BatchCard.vue?vue&type=script&lang=js"
import style0 from "./BatchCard.vue?vue&type=style&index=0&id=e7b6fbcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b6fbcc",
  null
  
)

export default component.exports